import { userMustSetupTwoFactor } from "@/modules/auth/domain/two-factor-policy";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { Button } from "@/components/ui/button";
import { useLocation, useNavigate } from "@tanstack/react-router";

type Props = {
  children: React.ReactNode;
};

export function RequireTwoFactorSetup({ children }: Props) {
  const { user, permissions, isLoading } = useAuthState();
  const navigate = useNavigate();
  const location = useLocation();

  if (isLoading) return children;

  const mustSetup = userMustSetupTwoFactor({
    permissions,
    twoFactorEnabled: (user as { twoFactorEnabled?: boolean } | null)
      ?.twoFactorEnabled,
  });

  if (!mustSetup) return children;

  const onProfile = location.pathname.startsWith("/app/profile");

  if (onProfile) return children;

  return (
    <div className="container flex min-h-[50vh] flex-col items-center justify-center gap-4 py-12 text-center">
      <h2 className="font-bold text-xl">ຕ້ອງເປີດ 2FA ກ່ອນ</h2>
      <p className="text-muted-foreground max-w-md text-sm">
        ບັນຊີຂອງທ່ານມີສິດອະນຸມັດ wallet ຫຼື ເບິ່ງ audit — ກະລຸນາຕັ້ງຄ່າ
        Two-Factor Authentication ໃນໂປຣໄຟລ໌ກ່ອນໃຊ້ງານຕໍ່
      </p>
      <Button
        onClick={() =>
          void navigate({ to: "/app/profile", search: { tab: "security" } })
        }
      >
        ໄປຕັ້ງຄ່າ 2FA
      </Button>
    </div>
  );
}
